import * as i0 from '@angular/core';
import { Injectable, Component, Input, NgModule } from '@angular/core';
import { Subject } from 'rxjs';
import * as i1 from '@angular/forms';
import { Validators, FormGroup, FormControl, ReactiveFormsModule } from '@angular/forms';
import { takeUntil, map } from 'rxjs/operators';
import * as i3 from '@ngrx/store';
import { select } from '@ngrx/store';
import { getStepDetails } from 'visa-store';
import * as i2 from 'reference-library';
import * as i4 from 'app-services-library';
import * as i6 from '@angular/router';
import * as i7 from '@angular/common';
import * as i8 from 'primeng/radiobutton';
import { PrimengLibraryModule } from 'primeng-library';

class CustomRadioButtonService {
    constructor() {
        this.invoicingRadioValue = new Subject();
        this.radioValues = {};
    }
    sendInvoicingRadioChange(value) {
        this.invoicingRadioValue.next({ radio: value });
    }
    getInvoicingRadioChange() {
        return this.invoicingRadioValue.asObservable();
    }
    setRadioValue(formControlName, value) {
        this.radioValues[formControlName] = value;
    }
    getRadioValue(formControlName) {
        return this.radioValues[formControlName];
    }
    setIsInitialValue(value) {
        this._isInitialValue = value;
    }
    getIsInitialValue() {
        return this._isInitialValue;
    }
}
CustomRadioButtonService.ɵfac = function CustomRadioButtonService_Factory(t) { return new (t || CustomRadioButtonService)(); };
CustomRadioButtonService.ɵprov = i0.ɵɵdefineInjectable({ token: CustomRadioButtonService, factory: CustomRadioButtonService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CustomRadioButtonService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

function CustomRadioButtonComponent_div_0_div_1_em_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "em", 6);
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
} }
function CustomRadioButtonComponent_div_0_div_1_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵelementStart(1, "p-radioButton", 8);
    i0.ɵɵlistener("onClick", function CustomRadioButtonComponent_div_0_div_1_div_2_Template_p_radioButton_onClick_1_listener() { i0.ɵɵrestoreView(_r8); const item_r6 = ctx.$implicit; const ctx_r7 = i0.ɵɵnextContext(3); return ctx_r7.setParentGroup(item_r6.code, "refDataArr", item_r6); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "label", 9);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r6 = ctx.$implicit;
    const ctx_r4 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("inputId", item_r6.id)("name", ctx_r4.formControlName)("value", item_r6.code)("formControlName", ctx_r4.formControlName);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("for", item_r6.id);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(item_r6.name);
} }
function CustomRadioButtonComponent_div_0_div_1_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 10);
    i0.ɵɵelementStart(1, "span", 11);
    i0.ɵɵtext(2, "Required");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function CustomRadioButtonComponent_div_0_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, CustomRadioButtonComponent_div_0_div_1_em_1_Template, 2, 0, "em", 3);
    i0.ɵɵtemplate(2, CustomRadioButtonComponent_div_0_div_1_div_2_Template, 4, 6, "div", 4);
    i0.ɵɵtemplate(3, CustomRadioButtonComponent_div_0_div_1_span_3_Template, 3, 0, "span", 5);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.inputParams == null ? null : ctx_r1.inputParams.mandatory);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r1.refDataArr);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (ctx_r1.inputParams == null ? null : ctx_r1.inputParams.mandatory) && ctx_r1.group.get(ctx_r1.formControlName).touched && !ctx_r1.hasValue);
} }
function CustomRadioButtonComponent_div_0_div_2_em_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "em", 6);
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
} }
function CustomRadioButtonComponent_div_0_div_2_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r15 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 13);
    i0.ɵɵelementStart(1, "input", 14);
    i0.ɵɵlistener("click", function CustomRadioButtonComponent_div_0_div_2_div_2_Template_input_click_1_listener() { i0.ɵɵrestoreView(_r15); const item_r12 = ctx.$implicit; const ctx_r14 = i0.ɵɵnextContext(3); return ctx_r14.setParentGroup(item_r12.name, "inputArray", item_r12); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "label", 15);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r12 = ctx.$implicit;
    const ctx_r10 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate("id", item_r12.code);
    i0.ɵɵpropertyInterpolate("name", ctx_r10.formControlName);
    i0.ɵɵpropertyInterpolate("value", item_r12.name);
    i0.ɵɵpropertyInterpolate("formControlName", ctx_r10.formControlName);
    i0.ɵɵproperty("checked", item_r12.name === ctx_r10.selectedValue);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate("for", item_r12.code);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(item_r12.name);
} }
function CustomRadioButtonComponent_div_0_div_2_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 10);
    i0.ɵɵtext(1, " Required ");
    i0.ɵɵelementEnd();
} }
function CustomRadioButtonComponent_div_0_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, CustomRadioButtonComponent_div_0_div_2_em_1_Template, 2, 0, "em", 3);
    i0.ɵɵtemplate(2, CustomRadioButtonComponent_div_0_div_2_div_2_Template, 4, 7, "div", 12);
    i0.ɵɵtemplate(3, CustomRadioButtonComponent_div_0_div_2_span_3_Template, 2, 0, "span", 5);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.inputParams == null ? null : ctx_r2.inputParams.mandatory);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r2.inputParams.properties.inputArray);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (ctx_r2.inputParams == null ? null : ctx_r2.inputParams.mandatory) && ctx_r2.group.get(ctx_r2.formControlName).touched && !ctx_r2.hasValue);
} }
const _c0 = function (a0) { return { "width": a0 }; };
function CustomRadioButtonComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵtemplate(1, CustomRadioButtonComponent_div_0_div_1_Template, 4, 3, "div", 2);
    i0.ɵɵtemplate(2, CustomRadioButtonComponent_div_0_div_2_Template, 4, 3, "div", 2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵstyleMap(i0.ɵɵpureFunction1(5, _c0, ctx_r0.inputParams == null ? null : ctx_r0.inputParams.style == null ? null : ctx_r0.inputParams.style.width));
    i0.ɵɵproperty("formGroup", ctx_r0.childGroup);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.refDataArr && ctx_r0.refDataArr.length > 0 && !(ctx_r0.inputParams.properties.inputArray && ctx_r0.inputParams.properties.inputArray.length > 0));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.inputParams.properties.inputArray && ctx_r0.inputParams.properties.inputArray.length > 0);
} }
class CustomRadioButtonComponent {
    constructor(fb, referenceLibraryService, store, appServicesLibraryService, cdRef, customRadioButtonService, route) {
        this.fb = fb;
        this.referenceLibraryService = referenceLibraryService;
        this.store = store;
        this.appServicesLibraryService = appServicesLibraryService;
        this.cdRef = cdRef;
        this.customRadioButtonService = customRadioButtonService;
        this.route = route;
        this.observableSubscription$ = new Subject();
    }
    ngOnInit() {
        var _a;
        const radioValidators = this.inputParams.mandatory ? [Validators.required] : [];
        this.group.addControl(this.inputParams.name, this.fb.control(this.inputParams.value, [this.requiredValidator.bind(this)]));
        if (this.inputParams.properties && this.inputParams.properties.isDataFromApi &&
            this.inputParams.properties.refercenceCodeForApiCall != '') {
            this.childGroup = new FormGroup({
                [this.formControlName]: new FormControl(((_a = this.inputParams.value) === null || _a === void 0 ? void 0 : _a.code) !== undefined ? this.inputParams.value.code : this.inputParams.value, [this.requiredValidator.bind(this)])
            });
            this.referenceLibraryService.getDataSource(this.inputParams.properties.refercenceCodeForApiCall, '').pipe(takeUntil(this.observableSubscription$)).subscribe((response) => {
                this.refDataArr = response;
                // console.log("this.refArrData radio button", this.refDataArr);
            });
        }
        else {
            if (this.inputParams.properties.inputArray && this.inputParams.properties.inputArray.length > 0) {
                this.inputParams.properties.inputArray = this.inputParams.properties.inputArray.map(x => {
                    if (typeof x === 'string') {
                        return {
                            code: this.uuid(),
                            name: x
                        };
                    }
                    else if (typeof x === 'object') {
                        return Object.assign(Object.assign({}, x), { code: x.data_field_name ? x.data_field_name : this.uuid(), name: x.name });
                    }
                });
            }
            this.childGroup = new FormGroup({
                [this.formControlName]: new FormControl(this.inputParams.value ? this.inputParams.value : null, [this.requiredValidator.bind(this)])
            });
            this.refDataArr = [];
        }
        if (this.inputData) {
            this.store.pipe(select(getStepDetails, { id: this.inputData.stepId })).pipe(takeUntil(this.observableSubscription$)).subscribe((data) => {
                var _a;
                this.inputData.stepStatusCode = (_a = data === null || data === void 0 ? void 0 : data.stepStatusDetails) === null || _a === void 0 ? void 0 : _a.stepStatusCode;
                this.disableAfterSubmitAndSave();
            });
        }
        this.childGroup.get(this.formControlName).valueChanges
            .pipe(map(value => !!value))
            .subscribe(hasValue => {
            this.hasValue = hasValue;
        });
        this.group.updateValueAndValidity();
        const isInitialValue = this.customRadioButtonService.getIsInitialValue();
        if (isInitialValue === true) {
            this.customRadioButtonService.setRadioValue(this.formControlName, this.inputParams.value[0]);
        }
        this.route.queryParams.subscribe(params => {
            const stepParameter = params['step'];
            if (stepParameter) {
                this.radioSubscription = this.customRadioButtonService.getRadioValue(this.formControlName);
                setTimeout(() => {
                    if (this.radioSubscription.name == "Upload your own invoice copy" || this.radioSubscription.name == "Upload your own Receipt") {
                        this.childGroup.get(this.formControlName).setValue(this.inputParams.properties.inputArray[1].name);
                        this.customRadioButtonService.sendInvoicingRadioChange(this.inputParams.value[1]);
                    }
                    else if (this.radioSubscription.name == "Generate Invoice" || this.radioSubscription.name == "Generate Receipt") {
                        this.childGroup.get(this.formControlName).setValue(this.inputParams.properties.inputArray[0].name);
                        this.customRadioButtonService.sendInvoicingRadioChange(this.inputParams.value[0]);
                    }
                }, 1000);
            }
            else {
                setTimeout(() => {
                    if (this.inputParams.value[0].name == "Generate Invoice" || this.inputParams.value[0].name == "Generate Receipt") {
                        this.childGroup.get(this.formControlName).setValue(this.inputParams.properties.inputArray[0].name);
                        this.customRadioButtonService.sendInvoicingRadioChange(this.inputParams.value[0]);
                        this.customRadioButtonService.setIsInitialValue(true);
                    }
                }, 1000);
            }
        });
    }
    ngAfterViewInit() {
        this.appServicesLibraryService.reportLoaded();
    }
    requiredValidator(control) {
        const currentValue = control.value;
        if (Array.isArray(currentValue) && this.inputParams.mandatory === true) {
            return { 'required': true };
        }
        return null;
    }
    uuid() {
        const val1 = Date.now().toString(36);
        const val2 = Math.random().toString(36).substring(2);
        return val1 + val2;
    }
    ngOnChanges(changes) {
        if (changes.group && changes.inputParams && changes.formControlName) {
            this.group.addControl(this.inputParams.name, this.fb.control(this.inputParams.value));
            if (this.inputParams.properties && this.inputParams.properties.isDataFromApi &&
                this.inputParams.properties.refercenceCodeForApiCall != '') {
                this.childGroup = new FormGroup({
                    [this.formControlName]: new FormControl(this.inputParams.value ? this.inputParams.value.code : null)
                });
                this.referenceLibraryService.getDataSource(this.inputParams.properties.refercenceCodeForApiCall, '').pipe(takeUntil(this.observableSubscription$)).subscribe((response) => {
                    this.refDataArr = response;
                    // console.log("this.refArrData radio button", this.refDataArr);
                });
            }
            else {
                if (this.inputParams.properties.inputArray && this.inputParams.properties.inputArray.length > 0) {
                    this.inputParams.properties.inputArray = this.inputParams.properties.inputArray.map(x => {
                        if (typeof x === 'string') {
                            return {
                                code: this.uuid(),
                                name: x
                            };
                        }
                        else if (typeof x === 'object') {
                            return Object.assign(Object.assign({}, x), { code: x.data_field_name ? x.data_field_name : this.uuid(), name: x.name });
                        }
                    });
                }
                this.childGroup = new FormGroup({
                    [this.formControlName]: new FormControl(this.inputParams.value ? this.inputParams.value : null)
                });
                this.selectedValue = this.inputParams.value;
                this.refDataArr = [];
            }
        }
        this.disableAfterSubmitAndSave();
    }
    setParentGroup(code, arrayName, item) {
        this.group.get([this.formControlName]).markAsDirty();
        this.group.get([this.formControlName]).patchValue(arrayName === 'refDataArr' ? this.refDataArr.find(x => x.code === code) : code);
        this.selectedValue = code;
        this.customRadioButtonService.setRadioValue(this.formControlName, item);
        this.customRadioButtonService.sendInvoicingRadioChange(item);
        this.customRadioButtonService.setIsInitialValue(false);
        // if(code == "Generate Invoice"){
        // }
        // else{
        //   this.customRadioButtonService.sendInvoicingRadioChange(code);
        // }
        /* if(code == "Generate Invoice"){
          this.childGroup.get(this.formControlName).setValue(this.inputParams.properties.inputArray[0].name);
        }else if(code == "Upload your own invoice copy"){
          this.childGroup.get(this.formControlName).setValue(this.inputParams.properties.inputArray[1].name);
        }  */
    }
    ngOnDestroy() {
        this.observableSubscription$.next();
        this.observableSubscription$.complete();
    }
    disableAfterSubmitAndSave() {
        this.userType = sessionStorage.getItem('userTypeRole');
        if (((this.userType === 'Petitioner' || this.userType === 'Attorney') && (this.inputData.stepStatusCode === 'COMPLETE' || this.inputData.stepStatusCode === 'NEW')) || (this.userType === 'Beneficiary' && (this.inputData.stepStatusCode === 'COMPLETE' || this.inputData.stepStatusCode === 'SUBMIT' || this.inputData.stepStatusCode === 'NEW'))) {
            this.childGroup.disable();
            this.group.disable();
        }
        else {
            this.childGroup.enable();
            this.group.enable();
        }
    }
}
CustomRadioButtonComponent.ɵfac = function CustomRadioButtonComponent_Factory(t) { return new (t || CustomRadioButtonComponent)(i0.ɵɵdirectiveInject(i1.FormBuilder), i0.ɵɵdirectiveInject(i2.ReferenceLibraryService), i0.ɵɵdirectiveInject(i3.Store), i0.ɵɵdirectiveInject(i4.AppServicesLibraryService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(CustomRadioButtonService), i0.ɵɵdirectiveInject(i6.ActivatedRoute)); };
CustomRadioButtonComponent.ɵcmp = i0.ɵɵdefineComponent({ type: CustomRadioButtonComponent, selectors: [["custom-radio-button"]], inputs: { formControlName: "formControlName", value: "value", inputParams: "inputParams", group: "group", inputData: "inputData", stepDetails: "stepDetails" }, features: [i0.ɵɵNgOnChangesFeature], decls: 1, vars: 1, consts: [["class", "form-group", 3, "formGroup", "style", 4, "ngIf"], [1, "form-group", 3, "formGroup"], [4, "ngIf"], ["class", "error-indicator", 4, "ngIf"], ["class", "p-field-checkbox", "style", "display: flex; float: left; text-align: left; justify-content: space-between; margin-right: 15px;", 4, "ngFor", "ngForOf"], ["class", "error", 4, "ngIf"], [1, "error-indicator"], [1, "p-field-checkbox", 2, "display", "flex", "float", "left", "text-align", "left", "justify-content", "space-between", "margin-right", "15px"], [3, "inputId", "name", "value", "formControlName", "onClick"], [1, "label-cls", "common-bene-class-for-translation", 3, "for"], [1, "error"], [1, "common-bene-class-for-translation"], ["class", "p-field-checkbox", "style", "display: flex; float: left; text-align: left; justify-content: space-between;; margin-right: 15px;", 4, "ngFor", "ngForOf"], [1, "p-field-checkbox", 2, "display", "flex", "float", "left", "text-align", "left", "justify-content", "space-between", "; margin-right", "15px"], ["type", "radio", 1, "switch-role-radio-style", 3, "id", "name", "value", "formControlName", "checked", "click"], [1, "label-cls", "label-max-width", "common-bene-class-for-translation", 3, "for"]], template: function CustomRadioButtonComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, CustomRadioButtonComponent_div_0_Template, 3, 7, "div", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.childGroup);
    } }, directives: [i7.NgIf, i1.NgControlStatusGroup, i1.FormGroupDirective, i7.NgForOf, i8.RadioButton, i1.NgControlStatus, i1.FormControlName, i1.RadioControlValueAccessor, i1.DefaultValueAccessor], styles: [".error[_ngcontent-%COMP%], .error-indicator[_ngcontent-%COMP%]{font-size:12px;color:#e31302;padding-top:3px}.error-indicator[_ngcontent-%COMP%]{position:relative;bottom:22px;left:-162px}.switch-role-radio-style[_ngcontent-%COMP%]{width:20px!important;height:20px;margin:0 5px 0 0;float:left}.label-max-width[_ngcontent-%COMP%]{max-width:calc(100% - 33px)}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CustomRadioButtonComponent, [{
        type: Component,
        args: [{
                selector: 'custom-radio-button',
                templateUrl: 'custom-radio-button.component.html',
                styleUrls: ['custom-radio-button.component.scss'
                ]
            }]
    }], function () { return [{ type: i1.FormBuilder }, { type: i2.ReferenceLibraryService }, { type: i3.Store }, { type: i4.AppServicesLibraryService }, { type: i0.ChangeDetectorRef }, { type: CustomRadioButtonService }, { type: i6.ActivatedRoute }]; }, { formControlName: [{
            type: Input
        }], value: [{
            type: Input
        }], inputParams: [{
            type: Input
        }], group: [{
            type: Input
        }], inputData: [{
            type: Input
        }], stepDetails: [{
            type: Input
        }] }); })();

class CustomRadioButtonModule {
}
CustomRadioButtonModule.ɵfac = function CustomRadioButtonModule_Factory(t) { return new (t || CustomRadioButtonModule)(); };
CustomRadioButtonModule.ɵmod = i0.ɵɵdefineNgModule({ type: CustomRadioButtonModule });
CustomRadioButtonModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[
            ReactiveFormsModule,
            PrimengLibraryModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(CustomRadioButtonModule, { declarations: [CustomRadioButtonComponent], imports: [ReactiveFormsModule,
        PrimengLibraryModule], exports: [CustomRadioButtonComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CustomRadioButtonModule, [{
        type: NgModule,
        args: [{
                declarations: [CustomRadioButtonComponent],
                imports: [
                    ReactiveFormsModule,
                    PrimengLibraryModule
                ],
                exports: [CustomRadioButtonComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of custom-radio-button
 */

/**
 * Generated bundle index. Do not edit.
 */

export { CustomRadioButtonComponent, CustomRadioButtonModule, CustomRadioButtonService };
//# sourceMappingURL=custom-radio-button.js.map
